// lib/features/floatingContent/floatingContent.slice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FloatingContentState } from "./floatingContent.state";
import { FloatingContentData } from "./floatingContent.types";
import { getFloatingContent } from "./floatingContent.thunk";

const initialState: FloatingContentState = {
  data: null,
  status: "idle",
  error: null,
};

const floatingContentSlice = createSlice({
  name: "floatingContent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFloatingContent.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getFloatingContent.fulfilled,
        (state, action: PayloadAction<FloatingContentData>) => {
          state.status = "success";
          state.data = action.payload;
        },
      )
      .addCase(
        getFloatingContent.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Floating content yüklenemedi.";
        },
      );
  },
});

export default floatingContentSlice.reducer;
